import { format } from "date-fns"
import { Receivable_Transaction_Type } from "gen/txn/models_pb"
import { Format } from "shared-ts/classes/timestamp"
import { UUID } from "shared-ts/classes/uuid"
import { ReceivableKind } from "shared-ts/receivables"
import { Chip } from "shared-web/components/base/informational/Chip"

import { getTransactionDetails } from "features/pos/customers/ReceivablesHistoryPanel/ReceivablesHistoryPanel"
import { classNames } from "lib/classNames"

export interface CreditHistoryHeaderProps {
  identifier: string
  txnIdentifier: string
  locationPrefix: string
  createdAt?: Date
  createdBy?: string
  txnId: UUID
  txnType: Receivable_Transaction_Type
  className?: string
  kind: ReceivableKind
}

export function CreditHistoryHeader({
  identifier,
  locationPrefix,
  txnId,
  createdAt,
  txnIdentifier,
  createdBy,
  txnType,
  className,
  kind,
}: CreditHistoryHeaderProps) {
  const { type, color, href } = getTransactionDetails(txnType, txnId)
  return (
    <div className={classNames("flex flex-col gap-1", className)}>
      <div className="flex flex-row items-center gap-2">
        <h2>{kind}</h2>
        <Chip
          isCopyable
          color="yellow"
          text={identifier}
          className="text-base"
        />
        <Chip color="gray" text={locationPrefix} className="text-base" />
      </div>
      <div className="flex flex-col gap-1">
        {createdAt && (
          <div className="text-v2-foreground-default-weak text-xs">
            Created by {createdBy} at{" "}
            {format(createdAt, Format.DATE_TIME_SHORT)}
          </div>
        )}
      </div>
      <div className="flex flex-row items-center gap-x-2 text-xs">
        <span className="text-v2-foreground-default-weak">
          Created by {type}:
        </span>
        <Chip color={color} size="normal" text={txnIdentifier} href={href} />
      </div>
    </div>
  )
}
